if (document.querySelectorAll('.four__cards__slider')) {
  document.querySelectorAll('.four__cards__slider').forEach(slider => {
    const container = slider.closest('.four__cards');
    const isLightTheme = container.classList.contains('four__cards__light');
    
    new Swiper(slider, {
        loop: !isLightTheme, 
        spaceBetween: 0,
        slidesPerView: 'auto',
        speed: 800,
        watchSlidesProgress: true,
        pagination: {
            el: slider.parentElement.querySelector('.four__cards-pagination'),
            clickable: true,
        },
        navigation: {
            nextEl: slider.parentElement.querySelector('.four__cards-next'),
            prevEl: slider.parentElement.querySelector('.four__cards-prev'),
        },
        breakpoints: {
            992: {
                slidesPerView: 4,
                spaceBetween: 20,
            },
        },
        autoplay: !isLightTheme ? { 
            delay: 3000,
            disableOnInteraction: false,
        } : false,
    });
  });
}
